import { faMultiply, faSpeaker, faTableCellsLarge } from "@fortawesome/pro-solid-svg-icons";
import { faTriangleExclamation, faVolume } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CdmPhysicalAudioDest } from "userful-chronos-app-common-js/dist/models/cdm/CdmPhysical";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { useTranslation } from "react-i18next";
import UserfulTooltip from "../../../Widgets/UserfulTooltip";

interface IProps {
    item: CdmPhysicalAudioDest;
    itemID: StringID;
    onDelete?: Function;
    inUse?: string;
}

export default function DestinationAudio(props: IProps) {
    const { t } = useTranslation();

    return (
        <>
            <div className="infoBar">
                <div className="infoBarElements">
                    <UserfulTooltip placement="top" title={t("Sources&Destinations.Destinations.audioDestination")}>
                        <div className="greenInfo">
                            <FontAwesomeIcon icon={faSpeaker} />
                        </div>
                    </UserfulTooltip>
                    {props.inUse && (
                        <UserfulTooltip placement="top" title={t("Shared.inUse")}>
                            <div className="yellowInfo">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                            </div>
                        </UserfulTooltip>
                    )}
                </div>
                {props.onDelete && (
                    <div className="infoBarActions">
                        <UserfulTooltip title={t("CommonUI.MappingGroups.removeDestination")}>
                            <div className="cardButtons" onClick={() => props.onDelete()}>
                                <FontAwesomeIcon icon={faMultiply} />
                            </div>
                        </UserfulTooltip>
                    </div>
                )}
            </div>
            <div className="nameBar">
                <div className="nameBarText">{props.item.name}</div>
            </div>
            <div className="contentBar">
                <FontAwesomeIcon className="audioIcon" icon={faVolume} />
                {props.item.description && (
                    <UserfulTooltip title={props.item.description}>
                        <div className="audioDescription">{props.item.description}</div>
                    </UserfulTooltip>
                )}
            </div>
        </>
    );
}
